<template>
  <div
    style="
      max-width: 70%;
      display: block;
      margin: auto;
      height: 250px !important;
    "
  >
    <canvas ref="chart"></canvas>
  </div>
</template>

<script>
import { Chart } from "chart.js";
export default {
  props: ["sectors"],

  data() {
    return {
      colors_list: [
        "#F5F5F5",
        "#ECE0FF",
        "#E1CDFF",
        "#B88EF6",
        "#A574EC",
        "#9561E2",
        "#573dff",
        "#2200ff",
        "#100075",
        "#6147ff",
        "#87afff"
      ]
    };
  },
  mounted() {
    var ctx = this.$refs.chart.getContext("2d");

    var labels = [];
    var values = [];
    var colors = [];
    var color_index = 0;
    this.sectors.forEach(sector => {
      labels.push(sector.name);
      values.push(Math.round(sector.value, 0));
      colors.push(this.colors_list[color_index]);
      color_index++;
      if (color_index == this.colors_list.length) {
        color_index = 0;
      }
    });

    var myChart = new Chart(ctx, {
      type: "doughnut",
      data: {
        labels: labels,
        datasets: [
          {
            data: values,
            backgroundColor: colors,
            borderColor: "#121212",
            hoverBorderColor: "rgba(255, 255, 255, .87)",
            borderWidth: 0,
            hoverBorderWidth: 2,
            hoverOffset: 5
          }
        ]
      },
      labels: labels,
      options: {
        maintainAspectRatio: false,
        cutoutPercentage: 70,
        responsive: true,
        plugins: {
          datalabels: {
            color: "#ffffff",
            labels: {
              title: {
                font: {
                  weight: "bold",
                  size: "14px"
                }
              }
            },
            formatter: value => {
              return value + "%";
            }
          },
          legend: {
            position: "right",
            display: false,
            labels: {
              fontFamily: "Lato",
              fontSize: 12,
              fontStyle: "bold",
              padding: 10,
              boxWidth: 10
            }
          },
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                return (
                  data.labels[tooltipItem.index] +
                  " : " +
                  Math.round(data.datasets[0].data[tooltipItem.index] * 100) /
                    100 +
                  "%"
                );
              }
            }
          }
        }
      }
    });
  }
};
</script>